export const aroma_soap = [
  {
    id: "k1",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwa8ce685c/crop/026537636_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Apple Orchard Lane",
    category1: "3-Wick Candle",
    Amount: "13.50",
    Rating: "4",
  },
  {
    id: "k2",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw06b3b4a0/crop/026498924_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Pinkberry Clouds",
    category1: "Fine Fragrance Mist",
    Amount: "16.50",
    Rating: "3.5",
  },
  {
    id: "k3",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwa80de4bb/crop/026502780_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Champagne Apple & Honey",
    category1:"Gentle & Clean Foaming Hand Soaps",
    Amount: "7.50",
    Rating: "4.5",
    desc: "What it smells like: a day at the spa with your fresh, herbal favorites. Fragrance notes: eucalyptus oil (clears the mind) and spearmint oil (soothes and uplifts).",
  },
  {
    id: "k4",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwf8e274eb/crop/026361035_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: " Orange Ginger",
    category1: "Pumice Body Scrub",
    Amount: "18.50",
    Rating: "4",
    desc: "What it smells like: a dreamy bedside bouquet. Fragrance notes: lavender oil (inspires tranquility) and vanilla absolute (calms the mind to encourage relaxation).",
  },
  {
    id: "an5",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwc897ffb1/crop/026410275_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New Fragrance",
    name: "Eucalyptus Tea",
    category1: "Gentle Gel Body Scrub",
    Amount: "24.50",
    Rating: "5",
    desc: "What it smells like: a self-care day with your citrusy essentials. Fragrance notes: chamomile oil (creates a sense of well-being) and bergamot oil (calms the mind and body).",
  },
  {
    id: "an6",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw2455126b/crop/026410945_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New",
    name: "Orange Ginger",
    category1: "Gentle & Clean Foaming Hand Soap",
    Amount: "7.50",
    Rating: "2.5",
    desc: "What it smells like: a fruity, spiced refresher. Fragrance notes: orange oil (invigorates and uplifts) and ginger oil (energizes your senses).",
  },
  {
    id: "an7",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwa393dab9/crop/026353262_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New Fragrance",
    name: "Eucalyptus Spearmint",
    category1: "Bath Soak",
    Amount: "18.50",
    Rating: "5",
    desc: "What it smells like: a fresh, herbal brew. Fragrance notes: zesty grapefruit, chamomile tea and fresh eucalyptus.",
  },
  {
    id: "an8",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw22111d6f/crop/026353200_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Eucalyptus Spearmint",
    category1: "Body Wash and Foam Bath",
    Amount: "14.50",
    Rating: "2.5",
    desc: "What it smells like: a fruity, spiced refresher. Fragrance notes: orange oil (invigorates and uplifts) and ginger oil (energizes your senses).",
  },
  {
    id: "an9",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw1b5146ea/crop/026353240_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Eucalyptus Spearmint",
    category1: "Moisturizing Body Wash",
    Amount: "15.50",
    Rating: "3",
    desc: "What it smells like: a day at the spa with your fresh, herbal favorites. Fragrance notes: eucalyptus oil (clears the mind) and spearmint oil (soothes and uplifts).",
  },
  {
    id: "an10",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwd7bab2f1/crop/026353230_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Eucalyptus Spearmint",
    category1: "Essential Oil Mist",
    Amount: "14.50",
    Rating: "4.5",
    desc: "What it smells like: a day at the spa with your fresh, herbal favorites. Fragrance notes: eucalyptus oil (clears the mind) and spearmint oil (soothes and uplifts).",
  },
  {
    id: "an11",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw386ad733/crop/026410944_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Eucalyptus Spearmint",
    category1: "Gentle & Clean Foaming Hand Soap",
    Amount: "7.50",
    Rating: "5",
    desc: "What it smells like: a fruity, spiced refresher. Fragrance notes: orange oil (invigorates and uplifts) and ginger oil (energizes your senses).",
  },
  {
    id: "an12",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw71938d61/crop/026410946_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Lavender Vanilla",
    category1: "Gentle & Clean Foaming Hand Soap",
    Amount: "7.50",
    Rating: "5",
    desc: "What it smells like: a day at the spa with your fresh, herbal favorites. Fragrance notes: eucalyptus oil (clears the mind) and spearmint oil (soothes and uplifts).",
  },
  {
    id: "an13",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwaa9a590e/crop/026400298_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New Fragrance",
    name: "Pineapple Lime Eucalyptus",
    category1: "Body Wash and Foam Bath",
    Amount: "15.50",
    Rating: "4",
    desc: "What it smells like: a self-care day with your citrusy essentials. Fragrance notes: chamomile oil (creates a sense of well-being) and bergamot oil (calms the mind and body).",
  },
  {
    id: "an14",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw77031493/crop/026400299_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New Fragrance",
    name: "Hibiscus Mandarin Violet",
    category1: "Body Wash and Foam Bath",
    Amount: "15.50",
    Rating: "4",
    desc: "What it smells like: a self-care day with your citrusy essentials. Fragrance notes: chamomile oil (creates a sense of well-being) and bergamot oil (calms the mind and body).",
  },
  {
    id: "an15",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwe52c7f04/crop/026403504_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New Fragrance",
    name: "Sandalwood Eucalyptus Mandarin",
    category1: "Body Wash and Foam Bath",
    Amount: "15.50",
    Rating: "5",
    desc: "What it smells like: a fruity, spiced refresher. Fragrance notes: orange oil (invigorates and uplifts) and ginger oil (energizes your senses).",
  },
  {
    id: "an16",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw405fd62d/crop/026401906_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New Fragrance",
    name: "Pineapple Lime Eucalyptus",
    category1: "Ultimate Hydration Body Care",
    Amount: "17.50",
    Rating: "5",
    desc: "What it smells like: a fruity, spiced refresher. Fragrance notes: orange oil (invigorates and uplifts) and ginger oil (energizes your senses).",
  },
  {
    id: "an17",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwb37ec169/crop/026403500_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New Fragrance",
    name: "Sandalwood Eucalyptus Mandarin",
    category1: "Ultimate Hydration Body Care",
    Amount: "17.50",
    Rating: "3",
    desc: "What it smells like: a day at the spa with your fresh, herbal favorites. Fragrance notes: eucalyptus oil (clears the mind) and spearmint oil (soothes and uplifts).",
  },
  {
    id: "an18",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwbfc18541/crop/026401907_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New Fragrance",
    name: "Hibiscus Mandarin Violet",
    category1: "Ultimate Hydration Body Care",
    Amount: "17.50",
    Rating: "3",
    desc: "What it smells like: a day at the spa with your fresh, herbal favorites. Fragrance notes: eucalyptus oil (clears the mind) and spearmint oil (soothes and uplifts).",
  },
];
